import React, { useEffect, useState, useContext } from "react";
import BackButton from "./BackButton";
import { PrimaryButton } from "../../common_components/Buttons";


function CreationFooter(props) {
    return (

        <div className="create-mission-card-footer" key={props.onClickBack}>
            {props.onClickBack ? <BackButton onClick={props.onClickBack} /> : <></>}
            {props.onClickSubmit ? <PrimaryButton onClick={props.onClickSubmit} text={props.buttonText} submitLoading={props.submitLoading} /> : <></>}
        </div>

    )

}

export default CreationFooter;